var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"w100_ h100_ backfff"},[(_vm.isShow)?_c('div',{staticClass:"w100_ h100_"},[_c('iframe',{ref:"iframeModel",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.url,"frameborder":"0"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }